////////////////////////////////////////////////////////////////////////////////
//                                                                             /
//                                                                             /
//  (C) Copyright 2026 Autodesk, Inc. All rights reserved.                     /
//                                                                             /
//                       ****  CONFIDENTIAL MATERIAL  ****                     /
//                                                                             /
//  The information contained herein is confidential, proprietary to           /
//  Autodesk, Inc., and considered a trade secret.  Use of this information    /
//  by anyone other than authorized employees of Autodesk, Inc. is granted     /
//  only under a written nondisclosure agreement, expressly prescribing        /
//  the scope and manner of such use.                                          /
//                                                                             /
////////////////////////////////////////////////////////////////////////////////

import {FileDestinationNamingType} from "../../clients/Classes";
import {TaskTrigger} from "../../Enums";
import {ScheduleData} from "@adsk/alloy-react-schedule/es/types";
import {RecurrenceSettings} from "../../dataModel/RecurrenceSettings";
import {ConvertAutodeskSchedule} from "../../converters/ConvertAutodeskSchedule";

export class OptionsState {
  name: string;
  description: string;
  trigger: TaskTrigger | undefined;
  schedule: RecurrenceSettings | undefined;
  startDate: Date | undefined;
  naming: FileDestinationNamingType;
  email: boolean;
  exportCsv: boolean;
  maintainFolderStructure: boolean;
  retainCloudModel: boolean;
  renameExisting: boolean;

  allowRecurring: boolean;

  constructor(
    name?: string,
    description?: string,
    trigger?: TaskTrigger | undefined,
    schedule?: RecurrenceSettings | undefined,
    startDate?: Date | undefined,
    naming?: FileDestinationNamingType,
    email?: boolean,
    exportCsv?: boolean,
    maintainFolderStructure?: boolean,
    retainCloudModel?: boolean,
    renameExisting?: boolean,
    allowRecurring?: boolean,
  ) {
    this.name = name ?? '';
    this.description = description ?? '';
    this.trigger = trigger ?? 'OnceNow';
    this.schedule = schedule;
    this.startDate = startDate;
    this.naming = naming ?? FileDestinationNamingType.AppendTimestamp;
    this.email = email ?? false;
    this.exportCsv = exportCsv ?? false;
    this.maintainFolderStructure = maintainFolderStructure ?? true;
    this.retainCloudModel = retainCloudModel ?? true;
    this.renameExisting = renameExisting ?? false;
    this.allowRecurring = allowRecurring ?? false;
  }
}